var MOVE_ORGANIZATION_OPTIONS, MoveOrganizationModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import OptionGroup from 'trunks/vue/share/components/option_group.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import HierarchicalSelect from 'trunks/vue/admin/components/libs/hierarchical_select_organization.js';

MOVE_ORGANIZATION_OPTIONS = _.map(['move_to_another_organization', 'move_to_root'], function(option_id) {
  return new Skylark.App.Model.FieldOption({
    id: option_id,
    value: Skylark.Helpers.translate("organization." + option_id)
  });
});

export default MoveOrganizationModal = Vue.extend({
  components: {
    modal: Modal,
    'OptionGroup': OptionGroup,
    'Popover': Popover,
    'hierarchical-select': HierarchicalSelect
  },
  props: {
    organization: {
      type: Object
    }
  },
  data: function() {
    return {
      resources: '/admin/organizations',
      formatedOptions: MOVE_ORGANIZATION_OPTIONS,
      selectedOrganization: null,
      initialHiddenOrganization: this.organization,
      selectedOption: null
    };
  },
  template: `<modal  title='移动组织'
        extendClass='organization-move-modal'
        @ensureClicked='ensureClicked'
        size='small'
        ref='organizationMoveModalRef'>
  <template>
    <div class="modal-body">
      <div class="modal-body-left">
        <OptionGroup  :initialValue='[selectedOption]'
                      @valueChange='optionSelectedChange'
                      :options='formatedOptions'
                      :canCancelSingleSelect='false' />
      </div>
      <div class="modal-body-right" v-if='!isMoveToRoot'>
        <Popover customClass='move-organization-popover'
                 position='bottom center'
                 :caret='false'
                 :blockContent='true'
                 ref='popoverRef'>
          <template slot="trigger">
            <div class="field-input-container">
              <div class="field-input">
                <div class="field-value">
                  <div class="selected-node" :class="selectedOrganizationClass">{{ selectedOrganizationName }}</div>
                </div>
                <div class="select-caret">
                  <i class="slp-caret-down placeholder"></i>
                </div>
              </div>
              <div class="error-message"></div>
            </div>
          </template>
          <div class='hierarchical-select-wrapper' slot='content'>
            <hierarchical-select
              :resources='resources'
              :initialHiddenNode='initialHiddenOrganization'
              @selectedNodeChange='selectedNodeChange'
              ref='organizationsSelectRef' />
          </div>
        </Popover>
      </div>
    </div>
  </template>
</modal>`,
  created: function() {
    return this.selectedOption = _.first(this.formatedOptions);
  },
  computed: {
    isMoveToRoot: function() {
      return this.selectedOption.id === 'move_to_root';
    },
    selectedOrganizationClass: function() {
      if (this.selectedOrganization) {
        return '';
      } else {
        return 'placeholder';
      }
    },
    selectedOrganizationName: function() {
      if (this.selectedOrganization) {
        return this.selectedOrganization.name;
      } else {
        return '请选择转移到的组织';
      }
    }
  },
  methods: {
    getParam: function() {
      if (this.isMoveToRoot) {
        return {
          url: `${this.resources}/${this.organization.id}/move?to_root=true`,
          data: null
        };
      } else {
        return {
          url: `${this.resources}/${this.organization.id}/move`,
          data: {
            target_id: this.selectedOrganization.id
          }
        };
      }
    },
    ensureClicked: function() {
      if (this.isMoveToRoot || this.selectedOrganization) {
        return this.doRequest(this.getParam());
      } else {
        Skylark.Bridge.newAlertify('请选择转移到的组织', {
          type: 'error'
        });
        return this.$refs.organizationMoveModalRef.open();
      }
    },
    doRequest: function(param) {
      return Skylark.Libs.Ajax.patch(param.url, {
        contentType: 'application/json; charset=utf-8',
        data: param.data,
        success: function() {
          Skylark.Bridge.newAlertify('转移成功', {
            type: 'success'
          });
          return location.reload();
        },
        error: function() {
          return Skylark.Bridge.newAlertify('转移失败', {
            type: 'error'
          });
        }
      });
    },
    optionSelectedChange: function(value) {
      this.selectedOption = value[0];
      if (this.isMoveToRoot) {
        return this.selectedOrganization = null;
      }
    },
    selectedNodeChange: function(node) {
      return this.selectedOrganization = node;
    }
  }
});
